import { createFileRoute } from '@tanstack/react-router'
import AuditPlanDetailPage from '@/pages/audit-plans/AuditPlanDetailPage'

export const Route = createFileRoute('/audit-plans/$planId')({
  component: AuditPlanDetailPage,
})
